module.exports = __webpack_public_path__ + "img/qrcode_appstore.c085c0a8.png";